import { useEffect, useMemo, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";

export const useInventoryDashboard = () => {

    const [filterValues, setFilterValues] = useState({ group: "", apiCall: { summary: false, volume: false }, });

    const [options, setOptions] = useState({});
    const [cardSummary, setCardSummary] = useState([])

    useEffect(() => {
        callautopopulate("asset_status", "asset_make", "locations", "assets_volumn_breakdown_options", "assets_card_view_options").then((res) => {
            const groupData = _.sortBy(res?.assets_card_view_options, "card_view_name")
            setOptions((prev) => ({
                ...prev,
                locations: _.sortBy(_.filter(res?.locations, loc => loc?.location), "location"),
                assetsVolumn: _.sortBy(res?.assets_volumn_breakdown_options, "volumn_breakdown_name"),
                groups: groupData
            }));
            setFilterValues({
                assets_card_view_options: groupData[0], assets_volumn_breakdown_options: res?.assets_volumn_breakdown_options[0],  apiCall: { summary: true, volume: true },
            })
        })
    }, [])

    useEffect(() => {
        filterValues?.apiCall?.summary && getAssetSummary();
    }, [filterValues?.apiCall?.summary]);
   
    const getAssetSummary = async () => {
        try {
            const payload = {        
                "card_grouping_key": filterValues?.assets_card_view_options?.card_view_key || "",
                "location_name": _.pluck(filterValues?.locations, "location").toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("GETASSETSCARDVIEWSUMMARY"), payload);
            if (!res?.body?.error_status) {
                setCardSummary(res?.body?.data?.asset_card_view_details)
                setFilterValues((prev) => ({ ...prev, apiCall: false}))
            }
        } catch (error) {
            console.error("error:::", error)
            
        }
    }

    const handleChange = (e, type) => {
        const { name, value } = e.target
        setFilterValues((prev) => ({ ...prev, [name]: value, isChange: true }));
    }


    return useMemo(() => ({
        filterValues, options, cardSummary, handleChange, setFilterValues, getAssetSummary
    }), [filterValues, options, cardSummary, handleChange, setFilterValues, getAssetSummary])
}